<template>
  <el-dialog
    :title="$t('text.add_room')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    v-if="dialogVisible"
    @close="closeDialog()"
    width="400px"
    class="batch-operation"
  >
    <el-form
      label-width="120px"
      :model="form"
      ref="form"
      :rules="rules"
      label-position="top"
    >
      <el-form-item :label="$t('text.room_number')" prop="roomNumber">
        <el-input
          v-model="form.roomNumber"
          :placeholder="$t('text.room_number')"
          class="wp-100"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        class="common-btn min-w-80"
        @click="submit()"
        :loading="loading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        roomNumber: ''
      },
      rules: {
        roomNumber: [
          {
            required: true,
            message: this.$t('text.please_enter_room_number'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    selectedFloor: {
      type: Object,
      require: true
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        roomNumber: ''
      }
      this.dialogVisible = false
    },
    submit() {
      this.loading = true
      ApiService.SaveRoom([
        {
          RoomNumber: this.form.roomNumber,
          FloorId: this.selectedFloor.FloorId
        }
      ])
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.added_successfully')
            })
            this.$emit('updateBuilding')
            this.closeDialog()
          } else {
            swal({
              icon: 'warning',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
